import { AnchorProduct } from "../../../domain/projections/AnchorProduct";

interface BenefitsContentDTO {
  readonly imageCollageUrl: string;
}

interface AnchorProductDTO {
  readonly id: string;
  readonly imageUrl: string;
  readonly order: number;
}

const mapAnchorProductsDtoToAnchorProducts = (anchorProductsDTO: AnchorProductDTO[]): AnchorProduct[] =>
  anchorProductsDTO.map((product: AnchorProductDTO) => ({
    id: product.id,
    imageUrl: product.imageUrl,
    order: product.order,
  }));

export type { BenefitsContentDTO };
export { mapAnchorProductsDtoToAnchorProducts };
